module.exports = __webpack_public_path__ + "static/media/game(13).0c9d5366.PNG";